import React, { Fragment, Component } from "react";
import Breadcrumb from "../../components/common/breadcrumb";
import MemberForm from "./components/form";
import Service from "../../services/memberService";

class CreateMember extends Component {
  state = {
    infoData: [],
    info: { sUrl: "" },
  };
  componentWillMount() { }
  componentDidUpdate() { }
  addMemberForm = (data) => {
    const { isEdit, info, imageUrl } = this.state;
    this.setState({ loader: true });
    console.log({ subMember: info.subMember });
    data["imageUrl"] = imageUrl;
    data["subMember"] = info.subMember;
    data["memberId"] = isEdit ? info._id : undefined;
    var method = isEdit ? "PUT" : "POST";
    Service.addStaffMemberInfo(data, method).then((response) => {
      if (!response.error) {
        this.props.history.push("/staff-members/all");
      }
    });
  };
  onClickToggle = () => {
    this.setState({ modalFormShow: false });
  };
  onChangeImage = (imageUrl) => {
    this.setState({ imageUrl: imageUrl });
  };

  removeImage = () => {
    this.setState({ imageUrl: undefined });
  };

  onChangeUrl = (name, url) => {
    if ((name && name !== "") || (url && url !== "")) {
      console.log({ url });
      var { info, urlEdit } = this.state;
      var stringUrl = "";
      var urlEdit1 = false;
      if (name && !urlEdit) {
        stringUrl = name.toLowerCase();
      } else if (url) {
        stringUrl = url.toLowerCase();
        urlEdit1 = true;
      }
      stringUrl = stringUrl.replace(/ /g, "_");
      stringUrl = stringUrl.replace(/,/g, "_");
      stringUrl = stringUrl.replace(/__/g, "_");
      if (info) {
        info["sUrl"] = stringUrl;
      } else {
        info = { sUrl: stringUrl };
      }
      this.setState({ info: info, urlEdit: urlEdit1 });
    }
  };

  onChangeActive = (memberId, value, index) => {
    console.log({ memberId, value });
    const { infoData } = this.state;
    this.setState({ loader: true });
    Service.onMemberReady(memberId, value).then((response) => {
      if (!response.error) {
        infoData[index].public = value;
        this.setState({ infoData, loader: false });
        // this.props.history.push("/products/all");
      }
      this.setState({ loader: false });
    });
  };
  render() {
    const {
      memberStatus,
      infoData,
      modalFormShow,
      loader,
      info,
      index,
      isEdit,
      imageUrl,
    } = this.state;
    const { loading, page, pageSize, totalRecords } = this.state;
    const memberFormProps = {
      info: info || {},
      imageUrl,
      onChangeImage: this.onChangeImage,
      removeImage: this.removeImage,
      active: this.state.active,
      onChangeUrl: this.onChangeUrl,
      searchProductUrl: "",
      searchUrlStatus: false,
      isEdit: this.state.isEdit,
      onChangeMemberId: (id) => {
        console.log({ id });
      },
      onClickConfirm: (data) => {
        //console.log(data)
        this.addMemberForm(data);
      },
      onClickActive: (active) => {
        this.setState({ active });
      },
      onChangeSubMember: (subMember) => {
        // var subMember1 = [];
        // for (let i = 0; i < subMember.length; i++) {
        //   subMember1.push(subMember[i]["label"]);
        // }
        for (let i = 0; i < subMember.length; i++) {
          subMember[i]["customOption"] = undefined;
        }
        info.subMember = subMember;
        this.setState({ info });
      },
      // MemberForm: infoData,
    };
    return (
      <Fragment>
        <Breadcrumb title={"Add"} parent="Member" />
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card border-0" style={{
                boxShadow: "1px 5px 24px 0 rgba(68, 102, 242, .05)",
                padding: "30px",
              }}>
                {loader && (
                  <div
                    style={{
                      position: "fixed",
                      top: "50%",
                      right: "45%",
                      zIndex: "+999",
                    }}
                  >
                    <div className="loader bg-white">
                      <div className="whirly-loader"> </div>
                    </div>
                  </div>
                )}

                <MemberForm {...memberFormProps} />
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default CreateMember;
